module.exports = __webpack_public_path__ + "media/images/blob-bg-be947617dc16eedcc16b7cea74dc1985.png";